import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

enum SpinnerState {
  Hidden,
  Showing,
  Visible,
  Hiding,
}

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private spinnerPromise: Promise<HTMLIonLoadingElement>;
  private state: SpinnerState = SpinnerState.Hidden;
  private shouldHide = false;
  private elementThatWasFocused;

  constructor(private loadingController: LoadingController) {}

  async showSpinner() {
    if (this.state === SpinnerState.Hidden) {
      this.state = SpinnerState.Showing;
      this.spinnerPromise = this.loadingController.create();
      const spinner = await this.spinnerPromise;
      this.elementThatWasFocused = document.activeElement;
      spinner.present();
      this.state = SpinnerState.Visible;
      if (this.shouldHide) {
        spinner.dismiss();
        this.state = SpinnerState.Hidden;
        this.shouldHide = false;
      }
    }
  }

  async hideSpinner(options?: { restoreFocusAfterMs: number }) {
    if (this.state === SpinnerState.Visible) {
      this.state = SpinnerState.Hiding;
      const spinner = await this.spinnerPromise;
      spinner.dismiss();
      this.state = SpinnerState.Hidden;
    } else if (this.state === SpinnerState.Showing) {
      this.shouldHide = true;
    }
    if (
      options?.restoreFocusAfterMs !== undefined && // can be 0
      this.elementThatWasFocused?.focus
    ) {
      setTimeout(() => this.elementThatWasFocused.focus(), options.restoreFocusAfterMs);
    }
  }
}
